export default __webpack_public_path__ + "static/media/B0004.be164100.png";